export const API_DATE_FORMAT = 'yyyy-MM-dd';
export const UI_DATE_FORMAT_LONG = 'd MMMM y';
export const UI_DATE_FORMAT_SHORT = 'dd MMM yy';
export const UI_DATE_FORMAT_LONG_WITHOUT_YEAR = 'd MMMM';
export const UI_DATE_FORMAT_SHORT_WITHOUT_YEAR = 'dd MMM';
export const UI_DATE_FORMAT_LONG_WITHOUT_MONTH = 'd';
export const UI_DATE_FORMAT_SHORT_WITHOUT_MONTH = 'dd';

export const UI_DATE_FORMAT_LONG_MONTH_YEAR = 'MMMM yyyy';

export const UI_TIME_FORMAT = 'HH:mm';
export const API_TIME_FORMAT = 'HH:mm';

export enum ScreenSize {
  'small' = 'small',
  'large' = 'large',
}
